import {
  Component,
  OnInit,
  Inject,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';
import { ToastrService } from 'ngx-toastr';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';


@Component({
  selector: 'app-issue-seller-indetail-credit-voucher-report',
  templateUrl: './issue-seller-indetail-credit-voucher-report.component.html',
  styleUrls: ['./issue-seller-indetail-credit-voucher-report.component.scss'],
})
export class IssueSellerIndetailCreditVoucherReportComponent implements OnInit {

  startDate: any;
  endDate: any;
  repName: any;
  issueName: any;
  issueDates: any;
  offRepName: any;
  reportType: any;
  issue_date = '';

  advtPaymentRegiInDetailsFormBeans: any;
  PaymentadvtOffInDTotal1: number = 0;
  PaymentadvtOffInDTotal_netamt: number = 0;

  constructor(
    private dialogRef: MatDialogRef<IssueSellerIndetailCreditVoucherReportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService,
    private toaster: ToastrService
  ) {
    this.startDate = data.startDate;
    this.endDate = data.endDate;
    this.repName = data.rep_name;
    this.issueName = data.issue_name;
    this.issueDates = data.issue_date;
    this.offRepName = data.off_rep_name;
    this.reportType = data.reportType;

    console.log('Start Date:', this.startDate);
    console.log('End Date:', this.endDate);
    console.log('Rep Name:', this.repName);
    console.log('Issue Name:', this.issueName);
    console.log('Issue Date:', this.issueDates);
    console.log('Off Rep Name:', this.offRepName);
    console.log('Report Type:', this.reportType);
  }

  ngOnInit(): void {
    const req = {
    req:{
      rep_name: this.repName,
      startDate: this.startDate,
      endDate: this.endDate,
      off_rep_name: this.offRepName,
      issue_name: this.issueName,
      issue_Date: this.issueDates
    }
    };

    this.service.getPaymentRegiInDetails11(req).subscribe({
      next: (data) => {
        this.advtPaymentRegiInDetailsFormBeans = data;
        this.PaymentadvtOffInDTotal1 = 0;
        this.PaymentadvtOffInDTotal_netamt = 0;

        for (let data1 of this.advtPaymentRegiInDetailsFormBeans) {
          this.PaymentadvtOffInDTotal1 += parseFloat(data1.rcv_amt) || 0;
          this.PaymentadvtOffInDTotal_netamt += parseFloat(data1.net_amt) || 0;
        }
      },
      error: (error) => {
        console.error('Error fetching Indetail data:', error);
        this.toaster.error('Failed to load detailed credit voucher report', 'Error');
      }
    });
  }

 exportExcel(fileName: string) {
  // Get the table element
  const element = document.getElementById('print-section');
  if (!element) {
    this.toaster.error('Table not found!');
    return;
  }

  // Use XLSX to convert the table to a worksheet
  const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

  // Create a new workbook and append the worksheet
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

  // Write workbook and save as Excel file
  XLSX.writeFile(wb, `${fileName}.xlsx`);
}

}
